/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ZhPrivacy.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuZh from "../../assets/component/HomepageMenuZh/HomepageMenuZh.js";

class ZhPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="ZhPrivacy-view">
        <Helmet>
          <title>私隱 - CheckPlus</title>
        </Helmet>
        {renderHomePageHeader(this)}
        {!!this.state.showModal && (
          <HomepageMenuZh closeModal={this.closeModal} />
        )}
        <div className="ZhPrivacy-section">
          <div className="ZhPrivacy-privacy">
            <div className="ZhPrivacy-privacyIcn" />
            <div className="ZhPrivacy-privacyTxt">私隱</div>
            <div className="ZhPrivacy-privacyDescription">
              你的數據應該是屬於你的。
            </div>
            <div className="ZhPrivacy-privacyDescription2">
              私隱對我們非常重要。 我們相信你的數據應該是屬於你的，所以
              CheckPlus
              承諾絕不將我們的用戶數據在未經您的同意下轉售給任何第三方公司。當我們設計
              CheckPlus 時，我們的團隊考慮到私隱，因此你可以放心。
            </div>
            <Link to="/ZhPrivacyPolicy">
              <div className="ZhPrivacy-privacyBtn">
                <div className="ZhPrivacy-privacyBtnTxt">
                  查看我們的私隱政策
                </div>
                <div className="ZhPrivacy-privacyNext" />
              </div>
            </Link>
          </div>

          <div className="ZhPrivacy-aws">
            <div className="ZhPrivacy-leftContainer">
              <div className="ZhPrivacy-leftGroup">
                <div className="ZhPrivacy-storageIcn" />
                <div className="ZhPrivacy-heading">安全數據處理</div>
                <div className="ZhPrivacy-description">
                  你的數據安全地儲存在我們 AWS 的伺服器中。
                </div>
                <div className="ZhPrivacy-tickContainer">
                  <div className="ZhPrivacy-tickIcn" />
                  <div className="ZhPrivacy-tickTxt">HTTPS</div>
                </div>
                <div className="ZhPrivacy-tickContainer">
                  <div className="ZhPrivacy-tickIcn" />
                  <div className="ZhPrivacy-tickTxt">SSL</div>
                </div>
                <div className="ZhPrivacy-tickContainer">
                  <div className="ZhPrivacy-tickIcn" />
                  <div className="ZhPrivacy-tickTxt">ISO27001 Certified</div>
                </div>
              </div>
              <div className="ZhPrivacy-blackFilter"></div>
            </div>
            <div className="ZhPrivacy-rightContainer">
              <div className="ZhPrivacy-awsLogo" />
            </div>
          </div>
          <div className="ZhPrivacy-stripe">
            <div className="ZhPrivacy-leftContainer">
              <div className="ZhPrivacy-leftGroup">
                <div className="ZhPrivacy-paymentIcn" />
                <div className="ZhPrivacy-heading">安全付款</div>
                <div className="ZhPrivacy-description">
                  所有卡號碼均使用 AES-256
                  技術加密，全球各大銀行和政府也使用相同的加密技術。
                </div>
              </div>
              <div className="ZhPrivacy-blackFilter"></div>
            </div>
            <div className="ZhPrivacy-rightContainer">
              <div className="ZhPrivacy-stripeLogo" />
            </div>
          </div>
          <div className="ZhPrivacy-checkplus">
            <div className="ZhPrivacy-leftContainer">
              <div className="ZhPrivacy-leftGroup">
                <div className="ZhPrivacy-commitmentIcn" />
                <div className="ZhPrivacy-heading">CheckPlus 的承諾</div>
                <div className="ZhPrivacy-description">
                  保護您的私隱是我們的承諾
                  ，我們會繼續積極尋找更多保護你私隱的方法。
                </div>
              </div>
              <div className="ZhPrivacy-blackFilter"></div>
            </div>
            <div className="ZhPrivacy-rightContainer">
              <div className="ZhPrivacy-checkplusLogo" />
            </div>
          </div>
        </div>

        <div className="ZhPrivacy-footer">
          <div className="ZhPrivacy-footerNav">
            <Link to="/ZhTeam">
              <div className="ZhPrivacy-footerNavItem">創辦人的故事</div>
            </Link>
            <Link to="/ZhFaq">
              <div className="ZhPrivacy-footerNavItem">常見問題</div>
            </Link>
            <Link to="/ZhContact">
              <div className="ZhPrivacy-footerNavItem">聯絡我們</div>
            </Link>

            <Link to="/ZhPrivacyPolicy">
              <div className="ZhPrivacy-footerNavItem">私隱政策</div>
            </Link>

            <Link to="/ZhTerms">
              <div className="ZhPrivacy-footerNavItem">使用條款</div>
            </Link>
          </div>

          <div className="ZhPrivacy-footer_text">
            香港九龍油塘四山街 11 號
            <br />
            華利工業大廈 5 樓 A 室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切權利。
          </div>
        </div>
      </div>
    );
  }
}

export default ZhPrivacy;
